import { ChainId } from '@kwikswap/bsc-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0x1Ee38d535d541c55C9dae27B12edf090C608E6Fb',
  [ChainId.TESTNET]: '0x53C43764255c17BD724F74c4eF150724AC50a3ed'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
